// src/pages/EvaaSurveyPage.js
import React, { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom'; // 2. Import useParams

import { useAuthenticatedApi } from '../hooks/useAuthenticatedApi'; // Adjust path if needed
import { useAuth } from '../hooks/useAuth';


import Spinner from '../components/ui/Spinner'; // Adjust path if needed

import SurveyDisplay from '../components/ui/SurveyDisplay'; // Adjust path if needed


import API_CONFIG from '../config/api';
const BASE_URL = API_CONFIG.BASE_URL;


function EvaaSurveyPreviewPage() {
	// 3. Get the URL parameters. The key 'surveyId' MUST match the name in the Route path (:surveyId)
	const { surveyId } = useParams();
	const navigate = useNavigate(); // Initialize useNavigate hook
	const { authenticatedFetch } = useAuthenticatedApi();
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState(null);
	const [surveyModel, setSurveyModel] = useState([]);
	const { isAuthenticated } = useAuth();

	const getSurvey = async () => {
		if (!isAuthenticated) {
			setIsLoading(false);
			return;
		}
		setIsLoading(true);
		setError(null); // Clear previous errors
		try {
			const result = await authenticatedFetch(BASE_URL + '/surveys/survey-by-id/' + surveyId, {}, "GET");
			if (result.status === 404) {
				// Redirect to 404 page with a custom message
				navigate('/404', { state: { message: `Survey with ID "${surveyId}" not found in database.` } });
				return;
			}
			if (!result.ok) {
				// Handle other non-2xx status codes (e.g., 500, 401, 403)
				let errorMessage = `Failed to fetch survey: Server responded with status ${result.status}.`;
				try {
					const errorBody = await result.json();
					if (errorBody && errorBody.message) {
						errorMessage = errorBody.message;
					}
				} catch (jsonError) {
					// Ignore if response body isn't JSON
				}
				console.error("EvaaSurveyPreviewPage API Error:", errorMessage, result);
				setError(errorMessage);
				setSurveyModel([]); // Clear model on error
				return; // Stop further execution
			}

			const datas = await result.json();
			if (datas) {
				setSurveyModel(datas);
			} else {
				console.error("API returned empty or invalid data structure:", datas);
				setError("Survey data is empty or malformed.");
				setSurveyModel([]); // Set empty list on unexpected response
			}
		} catch (err) {
			console.error("Error fetching survey list:", err);
			setError("Failed to load surveys. Please try again.");
		} finally {
			setIsLoading(false);
		}
	}
	// 4. Use useEffect to run code when the component mounts or surveyId changes
	useEffect(() => {
		if (isAuthenticated) {
			getSurvey();
		} else if (isAuthenticated === false) {
			setSurveyModel([]);
			setIsLoading(false);
		}
	}, [surveyId, isAuthenticated]); // The dependency array ensures this effect runs when surveyId changes
	
	const handleSurveySubmission = useCallback(async (surveyResults, surveyOptions) => {
		if (surveyOptions) {
			surveyOptions.showSaveError("You are in preview mode. No data are collected");
		}
	}, [surveyId, authenticatedFetch]);
	
	if (isLoading) {
		return (
			<div className="flex flex-col items-center justify-center min-h-screen gap-2">
				<Spinner text="Loading your survey..." size="md" className="mb-4" />
			</div>
		);
	}

	if (error) {
		return <div style={{ color: 'red' }}>Error: {error}</div>;
	}

	return (
			<div style={{ padding: '10px' }}>
					{/* The Survey component will now render with the updated title including the ID */}
					<SurveyDisplay surveyJson={surveyModel.survey} 
					surveyThemeJson={surveyModel.survey_theme} 
					onSurveyComplete={handleSurveySubmission}
					/>
			</div>
	);
}

export default EvaaSurveyPreviewPage;